import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 bg-white p-25" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4" }
const _hoisted_3 = {
  class: "p-0 m-0 list-unstyled d-flex align-items-center",
  style: {"gap":"6px"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { style: {"margin":"-18px 0 -15px 0"} }
const _hoisted_6 = { style: {"margin-top":"-11px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "mb-0" }, "Price Movement", -1)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeIntervals, (interval, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("button", {
              onClick: ($event: any) => (_ctx.changeTimeInterval(interval)),
              class: _normalizeClass([
              'p-0 border d-flex justify-content-center align-items-center rounded-1 hover-bg',
              _ctx.activeInterval === interval
                ? 'bg-primary text-white'
                : 'bg-transparent text-body',
            ]),
              style: {"width":"40px","height":"30px"}
            }, _toDisplayString(interval), 11, _hoisted_4)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "candlestick",
            height: "350",
            options: _ctx.priceMovement1,
            series: _ctx.price1
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "bar",
              height: "160",
              options: _ctx.priceMovement2,
              series: _ctx.price2
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}